<script>
import { mapGetters } from 'vuex'
import { getTeams } from '@/api/assetwise'

export default {
  data() {
    return {
      items: [{ value: '', text: this.$t('All') }],
      isLoading: false
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  created() {
    this.fetchItems()
  },
  methods: {
    async fetchItems() {
      try {
        this.isLoading = true

        const items = await getTeams({
          page_id: this.selectedBot.pageid,
          limit: Number.MAX_SAFE_INTEGER,
          offset: 0
        }).then((response) => {
          const { data = [] } = response.data
          return data
        })

        this.items = [
          { value: '', text: this.$t('All') },
          ...items.map((item) => ({
            value: item.team_id,
            text: item.team_name
          }))
        ]
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    }
  },
  render() {
    return this.$scopedSlots.default({
      options: this.items,
      loading: this.isLoading
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/providers/TeamOptionListProvider.vue